import React, { useEffect, useState } from "react";
import '../../../../assets/css/valuelist.css';
import MainWrapper from "../../../MainWrapper";
import { Link, Navigate } from "react-router-dom";
import Icon from "react-icons-kit";
import { ic_arrow_back, ic_mode_edit, ic_save } from 'react-icons-kit/md';
import { Table, Form, Button, InputGroup } from 'react-bootstrap';
// import { encrypted } from '../../../../_utils/helpers';
import { connect } from 'react-redux';
import Create from "./models/Create";
import ConfirmDelete from "./models/ConfirmDelete";
import {
  UNIT_REQUEST,
  UNIT_CREATE,
  UNIT_DELETE,
  UNIT_EDIT,
  UNIT_STATE_CHANGE
} from "../../../../_utils/constants/ProductCatalog";
import Loader from "../../../layouts/Loader";
import { toast } from 'react-toastify';

const Unit = ({
  auth: { auth, isAuthenticated },
  unit: { valueList, isCreated, isDeleted, isEdited, isLoading },
  fetchUnit,
  submitUnitCreate,
  submitUnitDelete,
  submitUnitEdit,
  changeReducerState
}) => {

  // states declarations
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const [inputVal, setInputVal] = useState('');
  const [deleteUnitId, setDeleteUnitId] = useState('');
  const [editUnitId, setEditUnitId] = useState('');
  const [editUnit, setEditUnit] = useState('');

  // use effect function called for authentication
  useEffect(() => {
    if (isAuthenticated) {
      fetchUnit(auth[0].token);
    }
  }, [auth, isAuthenticated]);

  // use effect function called after api success
  useEffect(() => {
    if (isCreated === true) {
      toast.success("Unit Created Successfully.");
      fetchUnit(auth[0].token);
      changeReducerState();
    }
    if (isDeleted === true) {
      toast.success("Unit Deleted Successfully.");
      fetchUnit(auth[0].token);
      changeReducerState();
    }
    if (isEdited === true) {
      toast.success("Unit Data Updated Successfully.");
      fetchUnit(auth[0].token);
      changeReducerState();
    }
  }, [isCreated, isDeleted, isEdited]);

  // function to open create modal
  const showCreateModal = () => {
    setCreateModalOpen(true);
  };

  // function to close create modal
  const hideCreateModal = () => {
    setCreateModalOpen(false);
  };

  // function called for input value change of create modal
  const handleCreateModalChange = (e) => {
    setInputVal(e.target.value);
  }

  // function called for create age demographic create api
  const handleCreateModalSubmit = (e) => {
    e.preventDefault();
    if (inputVal === '') {
      toast.error("Unit name cannot be empty.");
    } else {
      submitUnitCreate({
        "data": {
          "UnitName": inputVal,

        },
        "token": auth[0].token
      });
      hideCreateModal();
    }
  }

  // function to open confirm delete modal
  const showConfirmDeleteModal = (id) => {
    setDeleteUnitId(id);
    setConfirmDeleteModal(true);
  };

  // function to close confirm delete modal
  const hideConfirmDeleteModal = () => {
    setDeleteUnitId('');
    setConfirmDeleteModal(false);
  };

  // function called for delete age demographic delete api
  const handleConfirmDeleteSubmit = () => {
    submitUnitDelete({
      "UnitId": deleteUnitId,
      "token": auth[0].token
    });
    hideConfirmDeleteModal();
  }

  // function called on edit icon click
  const handleEditClick = (data) => {
    setEditUnitId(data.unitId);
    setEditUnit(data.unitName);
  }

  // function called to save edited data
  const handleEditSaveClick = (data) => {
    if (editUnit === '') {
      toast.error("Unit name cannot be empty.");
    } else {
      submitUnitEdit({
        "data": {
          "UnitId": data.unitId,
          "UnitName": editUnit,
        },
        "token": auth[0].token
      });
      setEditUnitId('');
      setEditUnit('');
    }
  }

  if (!isAuthenticated) return <Navigate to="/login" />;

  return (
    <MainWrapper>
      <Loader loading={isLoading}>
        <div className="container">

          <div className="sub-header mt-5 mb-3">
            <h2>Unit</h2>
            <Link className="btn btn-primary me-1" to="/admin"><Icon icon={ic_arrow_back} />Back to Value List</Link>
            <Create
              variant="primary"
              title={`Unit`}
              createModalOpen={createModalOpen}
              showCreateModal={showCreateModal}
              hideCreateModal={hideCreateModal}
              inputVal={inputVal}
              handleCreateModalChange={handleCreateModalChange}
              handleCreateModalSubmit={handleCreateModalSubmit}
            />
          </div>
          <Table responsive bordered>
            <thead>
              <tr>
                <th>Unit</th>
                <th width="50">Delete</th>
              </tr>
            </thead>
            <tbody>
              {valueList && valueList.length > 0 ? (
                valueList.map((item, index) => (
                  <tr key={index}>
                    {editUnitId === item.unitId ? (
                      <td>
                        <Form.Group>
                          <InputGroup>
                            <Form.Control type="text" value={editUnit} onChange={(evt) => setEditUnit(evt.target.value)} />
                            <Button variant="outline-secondary">
                              <Icon size={24} icon={ic_save} onClick={() => handleEditSaveClick(item)} />
                            </Button>
                          </InputGroup>
                        </Form.Group>
                      </td>
                    ) : (
                      <td>
                        {item.unitName}
                        <Icon role="button" className="float-end" size={24} icon={ic_mode_edit} onClick={() => handleEditClick(item)} />
                      </td>
                    )}
                    <td>
                      <ConfirmDelete variant="primary" title={`Unit`} showConfirmDeleteModal={() => showConfirmDeleteModal(item.unitId)} hideConfirmDeleteModal={hideConfirmDeleteModal} handleConfirmDeleteSubmit={handleConfirmDeleteSubmit} confirmDeleteModal={confirmDeleteModal} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={2}>
                    No Data Found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Loader>
    </MainWrapper>
  );
}

const mapStateToProps = ({ auth, unit }) => {
  return {
    auth,
    unit
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchUnit: (token) => dispatch({ type: UNIT_REQUEST, token }),
    submitUnitCreate: (data) => dispatch({ type: UNIT_CREATE, payload: data }),
    submitUnitDelete: (data) => dispatch({ type: UNIT_DELETE, payload: data }),
    submitUnitEdit: (data) => dispatch({ type: UNIT_EDIT, payload: data }),
    changeReducerState: () => dispatch({ type: UNIT_STATE_CHANGE })
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Unit);